module.exports = __webpack_public_path__ + "static/media/f_hairstyle_frizzy_medium_back.fbace621.png";